export class TwoFABackupCodeResModel {
  Id: number;
  BackupCode: string;
}
